module.exports = __webpack_public_path__ + "static/media/bg.people.c1ba48a8.png";